<div kalDialogContent [formGroup]="form">

    <kal-tab-group>

        <kal-tab *ngFor="let comment of commentsListControls; index as i"
                 [label]="$any(comment.value).label"
                 formArrayName="commentsList">

            <div [formGroupName]="i">

                <app-shared-comment-edit formControlName="comment"
                                         isOpened>
                </app-shared-comment-edit>

            </div>

        </kal-tab>

    </kal-tab-group>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        id="shared-add-comment-dialog_submit"
                        kalTheme="primary">
                Enregistrer
            </kal-button>

            <kal-button (click)="cancel()"
                        id="shared-add-comment-dialog_cancel"
                        kalTheme="secondary">
                Fermer
            </kal-button>

        </div>

    </div>

</div>
